import styled from "styled-components";

export const SDuplicateProjectProgressModal = styled.div`
  display: flex;
  flex-direction: column;
`;
